type CognitoModule = typeof import('amazon-cognito-identity-js');

let loading: Promise<CognitoModule> | undefined;

/**
 * Carrega o `amazon-cognito-identity-js` sob demanda (fora do JS inicial). O `buffer@4` que ele traz
 * lê `global` no topo do módulo, que não existe no navegador: o shim precisa rodar antes do import.
 */
export function loadCognito(): Promise<CognitoModule> {
  loading ??= (async () => {
    const scope = globalThis as { global?: unknown };
    scope.global ??= globalThis;
    return import('amazon-cognito-identity-js');
  })();
  return loading;
}

export type { CognitoModule };
